// @ts-nocheck
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './theme/themeContext';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import process from 'process';
window.process = process;

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.
root.render(
  <ThemeProvider>
    <CssBaseline />
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </ThemeProvider>
);